module.exports = __webpack_public_path__ + "img/1567657427.8abddf9f.jpg";